// SIX PANELS: Old and New Testament in each language.
//
//    Tgdaya 舊約 (Tg_OT)   Tgdaya 新約 (Tg_NT)
//    Truku  舊約 (Tr_OT)   Truku  新約 (Tr_NT)
//    Toda   舊約 (To_OT)   Toda   新約 (To_NT)   ← pending: no Toda column in the workbook
//
// Inside a panel, the highlight passages are its chapters. Built by build_bible.py — no
// panel is "the" Bible text: each is the same passages read in one language.
//
// Audio today: Tgdaya 新約 only (the recorded verse clips). The rest is text, marked 待補.
const load = (f) => { try { return require(`./${f}.json`); } catch (_) { return null; } };

const bibleTgdayaOt = load('bible_tgdaya_ot');
const bibleTgdayaNt = load('bible_tgdaya_nt');
const bibleTrukuOt  = load('bible_truku_ot');
const bibleTrukuNt  = load('bible_truku_nt');

const CREDITS = {
  bible_tgdaya_ot: { author: '聖經', translator: '聖經公會' },
  bible_tgdaya_nt: { author: '聖經', translator: '聖經公會' },
  bible_truku_ot:  { author: '聖經', translator: '聖經公會' },
  bible_truku_nt:  { author: '聖經', translator: '聖經公會' },
};

// Per-panel code. Namespaces word-timing keys in localStorage — panels share sentence ids
// (p01s01…), so they must never share a code.
export const STORY_CODES = {
  bible_tgdaya_ot: 'Tg_OT',
  bible_tgdaya_nt: 'Tg_NT',
  bible_truku_ot:  'Tr_OT',
  bible_truku_nt:  'Tr_NT',
};

// Panels that exist in the design but aren't ready to read. Shown in the library as 待補 so
// the six-panel shape is visible and honest, rather than silently one.
// Toda names supplied by Darryl; same noun-adjective order as the other two dialects; its
// scripture is still missing (no Toda column in the workbook), so it stays 待補.
// Truku was 待補 too (Darryl, 2026-07-14) pending its numbers/punctuation conformity pass and
// long-verse cuts — both now done (GNB English witness, all long-verse cuts reviewed,
// 2026-07-15), so it is restored to TEXTS below.
export const PENDING = [
  { id: 'bible_toda_ot', dialect: 'toda', title: 'Kari Pnsdhuwan Smudal',
    titleTranslation: '舊約選讀', note: '待補' },
  { id: 'bible_toda_nt', dialect: 'toda', title: 'Kari Pnsdhuwan Burah',
    titleTranslation: '新約選讀', note: '待補' },
];

// Units carry {src, origin, start, end, srcDur} baked into the data, so playback and the
// waveform both read from the same source.
function normalize(text) {
  const credited = { ...text, ...(CREDITS[text.id] || {}), code: STORY_CODES[text.id] || text.id };
  text = credited;
  if (text.paragraphs) return text;
  return {
    ...text,
    paragraphs: [{
      id: 'p01', text: null, translation: null, audio: null,
      sentences: (text.sentences || []).map(s => ({
        ...s, paragraphId: 'p01', paragraphIdx: 0,
      })),
    }],
  };
}

export const TEXTS = {
  tgdaya: [bibleTgdayaOt, bibleTgdayaNt].filter(Boolean).map(normalize),
  toda:   [],
  truku:  [bibleTrukuOt, bibleTrukuNt].filter(Boolean).map(normalize),
};
